export const KNO2_AZURE_AD_CONNECTION = 'kno2-azure-ad';
export const PCC_CONNECTION = 'PointClickCare';
